function longestCommonPrefixTwo(a, b) {
    a = a.toLowerCase();
    b = b.toLowerCase();
    let i = 0;
    while (i < a.length && i < b.length && a[i] === b[i]) i++;
    return a.slice(0, i).trim();
}

function pairwisePrefixPatterns(titles) {
    if (titles.length < 2) return [];

    let set = new Set();

    for (let i = 0; i < titles.length; i++) {
        for (let j = i + 1; j < titles.length; j++) {
            const p = longestCommonPrefixTwo(titles[i], titles[j]);
            if (p.length > 3) set.add(p.toLowerCase());
        }
    }

    let patterns = Array.from(set);

    let counts = patterns.map(p => ({
        pattern: p,
        count: titles.filter(t => t.toLowerCase().startsWith(p)).length
    }));

    counts.sort((a, b) => b.count - a.count || b.pattern.length - a.pattern.length);

    return counts;
}

module.exports = { pairwisePrefixPatterns };
